import { render, staticRenderFns } from "./edit.image-assets.page.vue?vue&type=template&id=d6ead332&"
import script from "./edit.image-assets.page.vue?vue&type=script&lang=js&"
export * from "./edit.image-assets.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports